import script from "./DefaultUserAvatar.vue?vue&type=script&setup=true&lang=ts"
export * from "./DefaultUserAvatar.vue?vue&type=script&setup=true&lang=ts"

import "./DefaultUserAvatar.vue?vue&type=style&index=0&id=2b06cf32&lang=scss"

const __exports__ = script;

export default __exports__